// Custom hook approach (in a separate file like hooks/useDebounce.js)
import { useCallback, useRef } from 'react';

export function useDebounce(fn, delay) {
  const timeoutRef = useRef(null);
  
  return useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    timeoutRef.current = setTimeout(() => {
      fn(...args);
    }, delay);
  }, [fn, delay]);
}
